export default __webpack_public_path__ + "static/media/pieczatka9.615b9da9.gif";